import { createComponent } from '@lit/react';
import * as React from 'react';
import {
  GenerateComponentTypeWithoutChildren,
  GeneratePropsWithRef,
} from '../../components/component-types-generics';
import { NavBreadcrumbWC } from './nav-breadcrumb.wc';

export type NavBreadcrumbProps =
  GenerateComponentTypeWithoutChildren<NavBreadcrumbWC>;

export type NavBreadcrumbPropsWithRef =
  GeneratePropsWithRef<NavBreadcrumbProps>;

export const NavBreadcrumb = createComponent({
  tagName: NavBreadcrumbWC.tagname,
  elementClass: NavBreadcrumbWC,
  react: React,
}) as NavBreadcrumbPropsWithRef;
